export default __webpack_public_path__ + "static/media/top-right-dots.9df4def0.svg";